import React from 'react';
import { FileProps, FolderProps } from '../Files/documents/types';
import AIFolderListItem from './AIFolderListItem';
import ApiLoader from '../ApiLoader';

interface AIFolderListProps {
  folders: FolderProps[];
  onFileSelect: (file: FileProps) => void;
  onSelectFolder: (folderId: string) => void;
  selectedFolderId: string | null;
  isLoading: boolean;
}

const AIFolderList: React.FC<AIFolderListProps> = ({
  folders,
  onFileSelect,
  onSelectFolder,
  selectedFolderId,
  isLoading,
}) => {


  return (
    <div className="h-full relative">
      {isLoading ? (
        <ApiLoader />
      ) : (
        <div className="space-y-2 overflow-y-auto h-full custom-scrollbar">
          {folders.map((folder) => (
            <AIFolderListItem
              key={folder.FolderID}
              folder={folder}
              onFileSelect={onFileSelect}
              onSelectFolder={onSelectFolder}
              selectedFolderId={selectedFolderId}
            />
          ))}
        </div>
      )}
    </div>
  );
};

export default AIFolderList;
